import commonMixin from '../../mixins/_common';
import flashMessageMixin from '../../mixins/_flash_messages';
import editedFlagMixin from '../../mixins/_edited_flag';
import deployReservationCheck from '../../mixins/_deploy_reservation_check';
import staticHtmlEditor from '../../components/static_html_editor/_index';
import titleEdit from './_title_edit_component';
import modalDeployConfirm from './_modal_deploy_confirm_component';
import modalDeployed from './_modal_deployed_component';
import modalReservationDatetimeEditor from '../../components/deploy/_modal_reservation_datetime_editor';
import editHistory from '../../components/static_html_editor/_edit_history';

// 各エリア定義
const AREAS_DATA = [
    {
        key: 'custom_page_freetext',
        name: 'カスタムページフリースペース',
        width: 1090,
    },
];

/**
 * デザイン編集のコンポーネント
 */
export default {
    name: 'designEdit',
    template: '#design_edit_template',
    data() {
        return {
            // 設定が変更されたか否かのフラグ
            edited: false,
            // 編集ID
            edit_id: null,
            // 編集中のデータ
            edit_data: {},
            // 変更一つ前のedit_dataデータ
            old_edit_data: {},
            // 文字数オーバーメッセージ表示フラグ
            over_text_length: false,
            // 反映フラグ
            should_publish: true,
            // 反映予約時刻
            reserve_time: null,
        };
    },
    props: {
        // テンプレートデータ
        template: {
            type: Object,
            default: () => ({}),
            required: false
        },
    },
    computed: {
        // 各エリア定義
        areasConfig: function () {
            return AREAS_DATA;
        },
        // templateデータが存在するか
        hasTemplate: function () {
            return (Object.keys(this.template).length > 0);
        },
        // 新規登録か否か
        isNew: function () {
            const params = this.$_params();
            return (typeof params.page_key === 'undefined');
        },
        // 静的HTML更新用テンプレート
        design_template: {
            get() {
                return {
                    freetext: this.edit_data['freetext'],
                    spfreetext1: this.edit_data['spfreetext1'],
                };
            },
            set(value) {
                this.edit_data['freetext'] = value['freetext'];
                this.edit_data['spfreetext1'] = value['spfreetext1'];
            },
        },
        // 連動フラグ
        device_sync: function () {
            return this.edit_data['device_sync'];
        },
    },
    mixins: [
        commonMixin,
        flashMessageMixin,
        editedFlagMixin,
        deployReservationCheck,
    ],
    watch: {
        // 編集完了時処理
        edited: function (value) {
            if (value === false) this.$refs.editHistory.clearHistory();
        },
    },
    components: {
        // タイトル編集コンポーネント
        'title-edit': titleEdit,
        // 反映前確認モーダルコンポーネント
        'modal-deploy-confirm': modalDeployConfirm,
        // 反映完了モーダルコンポーネント
        'modal-deployed': modalDeployed,
        // 静的HTML編集コンポーネント
        'static-html-editor': staticHtmlEditor,
        // 予約日時選択コンポーネント
        'modal-reservation-datetime-editor': modalReservationDatetimeEditor,
        // Undo / Redoコンポーネント
        'edit-history': editHistory,
    },
    created: async function () {
        // ページ編集データをセット
        this.setEditId();
        await this.setEditData();
        // 未保存アラート機能初期化(edit_dataを対象とする)
        this.iniEditedFlag('edit_data');
    },
    emits: ['update:template'],
    methods: {
        // ページデータをセットする
        setEditData: async function () {
            this.old_edit_data = {};
            // テンプレートが指定されていたらそれを使う
            if (this.hasTemplate) {
                this.edit_data = this.template;
                return;
            }

            const params = this.$_params();
            // 公開データ取得
            if (typeof params.page_key !== 'undefined') {
                this.edit_data = await this.getPage(null, params.page_key);
                return;
            }
            if (typeof params.id !== 'undefined') {
                // 通常下書き取得
                if (typeof params.copy === 'undefined') {
                    this.setEditId(params.id);
                    this.edit_data = await this.getPage(params.id);
                // コピー
                } else {
                    // 下書きのコピー
                    if (params.copy === 'draft') {
                        this.edit_data = await this.getPage(params.id, null, this.edit_id);
                    }
                    // 公開データのコピー
                    if (params.copy === 'released') {
                        this.edit_data = await this.getPage(null, params.id);
                    }
                    this.edit_data.page_key = '';
                    this.edit_data.name = this.edit_data.name + '(コピー)';
                }
            }
        },
        // 編集IDをセット
        setEditId: function (editId = null) {
            this.edit_id = (editId) ? editId : moment().unix();
            console.log('edit_id: ' + this.edit_id);
        },
        // ページデータを取得
        getPage: async function (editId, pageKey = null, copyDstId = null) {
            let data = {};
            let message = this.exception_error_message;
            this.$_loading();
            try {
                const response = await axios.get('/custom_page/get_page', {
                    params: {
                        edit_id: editId,
                        copy_dst_id: copyDstId,
                        page_key: pageKey,
                    }
                });
                if (response.data.status == 'OK') {
                    data = response.data.data;
                    message = '';
                } else {
                    message = response.data.message;
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            this.$_unloading();
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                }, this.$parent);
            }
            return data;
        },
        // 保存
        save: async function () {
            let message = this.exception_error_message;
            try {
                this.$_loading();
                const response = await axios.post('/custom_page/save', {
                    _method: 'PUT',
                    edit_id: this.edit_id,
                    copy_id: this.$_copyId(),
                    edit_data: this.edit_data,
                });
                if (response.data.status === 'OK') {
                    // エラーメッセージを空にする
                    message = '';
                    this.appendFlashMessage({
                        level: 'alert-success',
                        message: '保存が完了しました',
                        autoClear: true
                    }, this.$parent);
                    this.updateEdited(false);
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            this.$_unloading();
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                }, this.$parent);
            }
        },
        // 反映前処理
        beforeDeploy: function(shouldPublish = true, reserve_time = null) {

            this.should_publish = shouldPublish;
            this.reserve_time = reserve_time;

            // 新規登録の場合はページキー編集画面を開く
            if (this.isNew) {
                this.$refs.modalDeployConfirm.show();
            } else {
                this.deploy();
            }
        },
        // 反映
        deploy: async function () {
            let message = this.exception_error_message;
            try {
                this.$_loading();
                const response = await yahooAxios.post('/custom_page/deploy', {
                    _method: 'PUT',
                    edit_id: this.edit_id,
                    copy_id: this.$_copyId(),
                    edit_data: this.edit_data,
                    should_publish: this.should_publish,
                    reserve_time: this.reserve_time,
                });
                if (response.data.status === 'OK') {
                    // エラーメッセージを空にする
                    message = '';
                    this.$refs.modalDeployed.open();
                    this.updateEdited(false);
                } else {
                    message = response.data.message;
                }
            } catch (e) {
                await this.$root.$refs.yahooAuth.error(e);
                message = '';
            }
            this.$_unloading();
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                }, this.$parent);
            }
        },
        // プレビューモーダルを開く
        openPreview: function () {
            this.$parent.$refs.preview.show(this.edit_data.name, this.edit_data);
        },
        // 今すぐ反映
        deployAtOnce: async function () {
            try {
                // 反映予約有無をチェック
                const existsReservation = await this.existsDeployReservation();
                if(existsReservation) {
                    // 予約あり
                    if( await swalConfirm('ストアクリエイターProに、ご予約中の更新があります。このまま進むと、予約中の更新も同時に反映されますが、よろしいでしょうか？')) {
                        this.beforeDeploy(true);
                    }
                    return;
                }
                // 予約なし
                this.beforeDeploy(true);

            } catch (e) {
                const message = this.getCatchMessage(e);
                if (message) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: message,
                    }, this.$parent);
                }
            }
        },
        // 反映を予約
        reserveDeploy: async function () {
            try {
                // 予約存在をチェック
                const existsReservation = await this.existsDeployReservation();
                if(existsReservation) {
                    // 予約あり
                    if( await swalConfirm('ストアクリエイターProに、ご予約中の更新があります。今回の更新内容を、こちらの予約へ追加します。')) {
                        this.beforeDeploy(false);
                    }
                    return;
                }
                // 予約なし
                this.$refs.modalReservationDatetimeEditor.open();

            } catch (e) {
                const message = this.getCatchMessage(e);
                if (message) {
                    this.appendFlashMessage({
                        level: 'alert-danger',
                        message: message,
                    }, this.$parent);
                }
            }
        },
        // 前のページ戻る
        back: async function () {
            if (!await this.destConfirm()) {
                return;
            }
            // テンプレートありは初期化
            if (this.hasTemplate) {
                // スクロールをTOPへ
                window.scroll(0, 0);
                this.emitClearTemplate();
                return;
            }
            // テンプレートなしは一覧へ戻る
            window.location.href = '/custom_page';
        },

        // -------------------------
        // emit
        // -------------------------

        // テンプレートを空にする
        emitClearTemplate: function () {
            this.$emit('update:template', {});
        }
    }
};

